import { Row, Col } from "react-bootstrap";
import CollectiveMembers from "components/Collective/CollectiveMembers";
import UntMembers from "components/Collective/UntMembers";
import CollectiveAdd from "components/Collective/CollectiveAdd";
import CollectiveCreate from "components/Collective/CollectiveCreate";
import AddCollectiveMember from "components/Collective/AddCollectiveMember";

export default function TFamily(props) {
  return (
    <>
      {!props?.collective?.unitel?.members ? (
        <Row>
          {!props?.collective?.unitel?.members ? (
            <Col md="4" lg="0">
              <CollectiveCreate {...props} />
            </Col>
          ) : null}
          {props?.consumer ? (
            <Col md="4" lg="0">
              <CollectiveAdd {...props} />
            </Col>
          ) : null}
        </Row>
      ) : null}

      <Row>
        <Col md="6" lg="6">
          <CollectiveMembers
            collective={props.collective}
            showAlert={props.showAlert}
            notify={props.notify}
            refreshCollective={props.refreshCollective}
          ></CollectiveMembers>
        </Col>
        <Col md="6" lg="6">
          <UntMembers
            notify={props.notify}
            collective={props.collective}
            refreshCollective={props.refreshCollective}
          ></UntMembers>
        </Col>
        {props?.collective?.unitel &&
        props?.collective?.unitel?.members?.length < 5 ? (
          <Col md="4" lg="3">
            <AddCollectiveMember {...props} />
          </Col>
        ) : null}
      </Row>
    </>
  );
}
